import { defaultFormItemLayout } from '../../modules/FormItems'
import React, { Component, Fragment } from 'react'
import {
  Button,
  Card,
  Col,
  Icon,
  Input,
  message,
  Pagination,
  Row,
  Select,
  Spin,
  Form,
  Checkbox,
} from 'antd'
import moment from 'moment'
import _, { pick } from 'lodash'
import { execute, idMaker, strVal } from '../../modules/Utils'
import Members from '../../api/Members'
import EditModal from '../People/Member/Modal/Profile'
import Authentication from '../../modules/Authentication'
import AddPhoneBook from './Modal/AddPhoneBook'
import PhonebookGrid from './PhoneBook/Grid'
import List from './PhoneBook/List'
import BulkEmailCont from '../Common/Email/BulkEmail/BulkEmailCont'
import RefreshButton from '../../elements/Buttons/RefreshButton'

const Search = Input.Search

class PhoneBook extends Component {
  constructor(props) {
    super(props)
    this.state = {
      current: 1,
      list: [],
      data: [],
      selection: [],
      currentList: [],
      visible: false,
      listView: false,
      showModal: false,
      member: {},
      fetching: true,
      searchWord: '',
      filterByType: 'All',
      pagination: {
        showSizeChanger: true,
        pageSizeOptions: ['12', '24', '30', '60'],
        showTotal: (total) => {
          return `${total} Record`
        },
      },
    }
    this.api = new Members()
    this.pagination = { pageSize: 12, current: 1 }
    this.auth = new Authentication()
  }

  async componentDidMount() {
    await this.fetch()
  }

  ids = idMaker()
  tableRef = React.createRef()
  fetch = async () => {
    this.setState({ fetching: true })
    let response = await this.api.phonebook()
    let list = await response.json()
    let currentList = list.slice(0, this.pagination.pageSize)
    this.setState({ data: list, list, currentList, fetching: false })
  }
  showModal = () => {
    this.setState({
      visible: true,
    })
  }
  handleOk = () => {
    this.setState({
      visible: false,
      showModal: false,
    })
  }
  handleCancel = async (updated) => {
    this.setState({
      showModal: false,
      visible: false,
    })
    if (updated === true) {
      await this.fetch()
      this.handleOnSearch({ target: { value: this.state.searchWord } })
    }
  }
  handlePageChange = (page, pageSize) => {
    let currentList = this.state.list.slice((page - 1) * pageSize, (page - 1) * pageSize + pageSize)
    this.pagination.pageSize = pageSize
    this.pagination.current = page

    this.setState({ currentList })
  }
  handleOnSearch = (e) => {
    let filteredExact = this.state.data
      .map((a) => a)
      .filter((row) =>
        this.state.filterByType === 'All'
          ? true
          : row.tags.find((t) => t.name === this.state.filterByType).status !== null
      )
      .filter((row) => {
        return (
          strVal(row, 'fn').toUpperCase().includes(e.target.value.toUpperCase()) ||
          strVal(row, 'email.label').toUpperCase().includes(e.target.value.toUpperCase()) ||
          strVal(row, 'tradeName').toUpperCase().includes(e.target.value.toUpperCase())
        )
      })
    let filteredSimilar = this.state.data
      .map((a) => a)
      .filter((row) =>
        this.state.filterByType === 'All'
          ? true
          : row.tags.find((t) => t.name === this.state.filterByType).status !== null
      )
      .filter((row) => {
        return _.get(row, 'orgs', [''])
          .map((r) => r.name)
          .join(' - ')
          .toUpperCase()
          .includes(e.target.value.toUpperCase())
      })

    let filtered = _.unionBy(filteredExact, filteredSimilar, '_id')

    const pagination = { ...this.state.pagination }
    pagination.total = filtered.length
    let currentList = filtered.slice(0, this.pagination.pageSize)
    console.log({ currentList })
    this.setState({ list: filtered, searchWord: e.target.value, currentList })
  }
  handleOnRowClick = (record, index, event) => {
    this.setState({ member: record, type: 'phonebook', showModal: true })
  }
  changeView = () => {
    this.setState({ listView: !this.state.listView })
  }
  showEmail = async () => {
    const selection = this.state.selection.map((t) => this.state.list.find((i) => i._id === t))
    try {
      this.setState({
        visibleEmail: true,
        emailTemplate: '',
        fetchingEmailTemplate: false,
        emailFiles: [],
        emails: selection.map((s) => strVal(s, 'email.label')),
        emailLines: selection,
        emailDetails: {},
      })
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({
        fetchingEmailTemplate: false,
      })
    }
  }
  onCancelEmail = () => {
    this.setState({
      visibleEmail: false,
      emailDetails: {},
      selection: [],
    })
  }
  remove = async (member) => {
    await execute(this, this.api.remove.bind(this, pick(member, ['_key', '_rev', '_id'])), message)
    await this.fetch()
    this.handleOnSearch({ target: { value: this.state.searchWord } })
  }
  toggleSelection = (key) => {
    let selection = [...this.state.selection]
    const keyIndex = selection.indexOf(key)
    if (keyIndex >= 0) {
      selection = [...selection.slice(0, keyIndex), ...selection.slice(keyIndex + 1)]
    } else {
      selection.push(key)
    }
    this.setState({ selection })
  }
  toggleAll = () => {
    const selectAll = !this.state.selectAll
    const selection = []
    if (selectAll) {
      const wrappedInstance = this.tableRef.current
      const currentRecords = wrappedInstance.getResolvedState().sortedData
      currentRecords.forEach((item) => {
        selection.push(item._original._id)
      })
    }

    this.setState({ selectAll, selection })
  }
  isSelected = (key) => {
    return this.state.selection.includes(key)
  }

  onChangePartner = (value) => {
    let filtered = this.state.data
      .filter((row) =>
        value === 'All'
          ? true
          : _.get(
              row.tags.find((t) => t.name === value),
              'status'
            ) !== null
      )
      .filter((row) => {
        return (
          strVal(row, 'fn').toUpperCase().includes(this.state.searchWord.toUpperCase()) ||
          strVal(row, 'email.label').toUpperCase().includes(this.state.searchWord.toUpperCase()) ||
          strVal(row, 'tradeName').toUpperCase().includes(this.state.searchWord.toUpperCase())
        )
      })
    let currentList = filtered.slice(0, this.pagination.pageSize)
    console.log(filtered.length)
    this.setState({ list: filtered, filterByType: value, currentList })
  }

  onChangeDuplicated = (value) => {
    let filtered = this.state.data

    if (value.target.checked) {
      const lookup = filtered.reduce((a, e) => {
        a[e.fn] = e.fn in a ? ++a[e.fn] : 0
        return a
      }, {})

      filtered = filtered.filter((e) => lookup[e.fn])
    }

    let currentList = filtered.slice(0, this.pagination.pageSize)
    console.log(filtered.length)
    this.setState({ list: filtered, filterByType: value, currentList })
  }

  render() {
    const { visibleEmail, emails, emailDetails } = this.state
    return (
      <Fragment>
        <Row key="1">
          <Col style={{ paddingTop: '1%' }} span={24}>
            <div style={{ marginLeft: 20, float: 'left' }}>
              {/*<Row style={{*/}
              {/*    marginLeft: 20,*/}
              {/*    marginRight: 60,*/}
              {/*    padding: 3,*/}
              {/*  }}>*/}
              <AddPhoneBook
                key={moment().unix().toString()}
                visible={this.state.visible}
                handleOk={this.handleOk}
                handleCancel={this.handleCancel}
                data={this.state.data}
              />
              <Button icon="plus" type="primary" onClick={this.showModal}>
                New{' '}
              </Button>
            </div>
            <div style={{ marginRight: 20, float: 'right' }}>
              <Search
                placeholder="You can search full name or Email  ... "
                style={{ width: '500px' }}
                onSearch={(value) => this.handleOnSearch({ target: { value } })}
                onChange={this.handleOnSearch}
              />
              <Button
                type={'dashed'}
                icon={this.state.listView ? 'appstore' : 'bars'}
                onClick={this.changeView}
                style={{ marginLeft: 5, marginRight: 5 }}>
                View
              </Button>
              <RefreshButton onClick={this.fetch} size={'default'} />
            </div>
          </Col>
          <Col span={24}>
            <div style={{ marginLeft: 20, float: 'left', width: '50%' }}>
              <Form.Item {...defaultFormItemLayout} label={'Show Possible Duplications'}>
                <Checkbox onChange={(value) => this.onChangeDuplicated(value)} />
              </Form.Item>
            </div>
            <div style={{ marginRight: 20, float: 'right', width: 400 }}>
              <Form.Item {...defaultFormItemLayout} label={'Filter By Type'}>
                <Select onChange={(value) => this.onChangePartner(value)} style={{ width: '100%' }}>
                  <Select.Option value="All">Show All</Select.Option>
                  <Select.Option value="Client">Clients</Select.Option>
                  <Select.Option value="Vendor">Vendors</Select.Option>
                  <Select.Option value="HR">HR</Select.Option>
                  <Select.Option value="Corporate">Corporate</Select.Option>
                  <Select.Option value="Lender">Lenders</Select.Option>
                  <Select.Option value="Government">Government</Select.Option>
                </Select>
              </Form.Item>
            </div>
          </Col>
        </Row>
        <Row key="2">
          <Col span={24}>
            <Spin
              indicator={<Icon type="loading" style={{ fontSize: 50 }} spin />}
              spinning={this.state.fetching}>
              {this.state.listView ? (
                <Card bordered={false} style={{ marginTop: 10 }}>
                  <BulkEmailCont
                    key={this.ids.next().value}
                    visible={visibleEmail}
                    emails={emails}
                    onCancel={this.onCancelEmail}
                    email={emailDetails}
                  />
                  <List
                    selectAll={this.state.selectAll}
                    selection={this.state.selection}
                    tableRef={this.tableRef}
                    fetching={this.state.fetching}
                    toggleSelection={this.toggleSelection}
                    toggleAll={this.toggleAll}
                    isSelected={this.isSelected}
                    showEmail={this.showEmail}
                    handleOnRowClick={this.handleOnRowClick}
                    list={this.state.list}
                    fetch={this.fetch}
                  />
                </Card>
              ) : (
                <PhonebookGrid
                  currentList={this.state.currentList.map((m) => {
                    m.display = strVal(m, 'fn').slice(0, 40)
                    if (strVal(m, 'fn').length > 40) m.display += '...'
                    return m
                  })}
                  auth={this.auth}
                  handleOnRowClick={this.handleOnRowClick}
                />
              )}
            </Spin>
          </Col>
        </Row>
        <Row key="3">
          {!this.state.fetching && !this.state.listView && (
            <Pagination
              style={{
                float: 'right',
                marginTop: '10px',
                paddingBottom: '20px',
              }}
              {...this.state.pagination}
              onShowSizeChange={this.handlePageChange}
              onChange={this.handlePageChange}
              pageSize={this.pagination.pageSize}
              current={this.pagination.current}
              total={this.state.list.length}
            />
          )}
        </Row>
        <EditModal
          key={moment()}
          visible={this.state.showModal}
          handleCancel={this.handleCancel}
          parent="phonebook"
          member={this.state.member}
        />
      </Fragment>
    )
  }
}

export default PhoneBook
